import { render } from "./SendResult.vue?vue&type=template&id=8b9bb342&scoped=true&ts=true"
import script from "./SendResult.vue?vue&type=script&lang=ts"
export * from "./SendResult.vue?vue&type=script&lang=ts"

import "./SendResult.vue?vue&type=style&index=0&id=8b9bb342&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9bb342"]])

export default __exports__